import { useEffect } from "react";

interface MetaOptions {
  title: string;
  description?: string;
  keywords?: string;
}

function setMeta(
  attr: "name" | "property",
  key: string,
  content: string,
): void {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useDocumentMeta({ title, description, keywords }: MetaOptions): void {
  useEffect(() => {
    document.title = title;
    setMeta("property", "og:title", title);
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
    }
    if (keywords) {
      setMeta("name", "keywords", keywords);
    }
  }, [title, description, keywords]);
}

export default useDocumentMeta;